/* eslint-disable camelcase */
const intialState = {};
const reducer = (state = intialState, action) => {
  switch (action.type) {
    case 'SET_EMANDATE_DETAIS': {
      return {
        ...state,
        eMandateDetails: action.data,
      };
    }
    case 'SET_MANDATE_REFERENCE_ID': {
      return {
        ...state,
        referenceID: action.data?.reference_id,
      };
    }
    case 'RESET_MANDATE_DETAILS': {
      return {
        state: intialState,
      };
    }
    case 'SET_MANDATE_SUCCESS': {
      return {
        ...state,
        eMandateSuccess: action.data,
      };
    }
    default: {
      return state;
    }
  }
};
export default reducer;
